
(()=>{
  'use strict';

  /* ========= Shorthand & DOM ========= */
  const $=id=>document.getElementById(id);
  const E={
    time:$('time'), next:$('next'),
    play:$('playPauseBtn'), back:$('rewindBtn'), fwd:$('forwardBtn'), reset:$('resetBtn'), mute:$('muteBtn'),
    settings:$('settingsBtn'), skip:$('skipBtn'),
    overlay:$('overlay'), drawer:$('drawer'), closeDrawer:$('closeDrawer'),
    mechBg:$('mechBg'),
    start:$('startTime'), dipLeads:$('bigDipLeads'), greenLead:$('greenLead'),
    annBD:$('annBD'), annG1:$('annG1'), annG2:$('annG2'), annG3:$('annG3'),
    alt:$('altNames'), voiceSel:$('voiceSelect'), testVoice:$('testVoiceBtn'),
    seek:$('seekStep'), defaults:$('defaultsBtn'), apply:$('applyBtn'), save:$('applySaveBtn')
  };

  /* ========= Utils ========= */
  const toSec=mmss=>{const [m,s]=(mmss||'0:0').split(':').map(x=>parseInt(x,10)||0);return m*60+s};
  const fmt=sec=>{sec=Math.max(0,sec|0);const m=(sec/60)|0,s=sec%60;return String(m).padStart(2,'0')+':'+String(s).padStart(2,'0')};
  const key=it=>`${it.kind}|${it.tag}|${it.t}`;

  /* ========= Constants ========= */
  const DIP=['6:25','5:05','3:45','2:25','1:05'].map(toSec);
  const G1=['9:30','8:00','6:30','5:00','3:30','2:00','0:30'].map(toSec);
  const G2=['9:00','7:30','6:00','4:30','3:00','1:30'].map(toSec);
  const G3=['8:30','7:00','5:30','4:00','2:30','1:00'].map(toSec);
  const G1L=['Arrow','Square','Triangle','Heart','Spiral','Circle','Star'];
  const G2L=['Circle','Star','Arrow','Square','Triangle','Heart'];
  const G3L=['Heart','Spiral','Circle','Star','Arrow','Square'];
  const ALT={Arrow:'Throne Left',Circle:'Throne Right',Triangle:'Left',Heart:'Right',Spiral:'Door Right',Square:'Door Left',Star:'Door'};
  const LS={voice:'dhuum_voice',seek:'dhuum_seek',start:'dhuum_start',dipLead:'dhuum_diplead',greenLead:'dhuum_greenlead',annBD:'dhuum_ann_bd',annG1:'dhuum_ann_g1',annG2:'dhuum_ann_g2',annG3:'dhuum_ann_g3',alt:'dhuum_alt'};
  const VOICE_PREF="Microsoft Jenny Online (Natural) - English (United States) (en-US)";

  /* ========= State ========= */
  let running=false,startEpoch=0,startTotal=toSec('09:58'),remaining=startTotal,lastSec=remaining|0;
  let schedule=[],ptr=0,fired=new Set();
  let muted=false,primed=false,voiceName='';
  let bgHold=null; // {tag:'bd'|'g1'|'g2'|'g3', endAt:number}

  /* ========= Voice ========= */
  const loadVoices=()=>{
    if(!('speechSynthesis'in window)) return [];
    const list=window.speechSynthesis.getVoices().filter(v=>/en-/i.test(v.lang||'')||/English/i.test(v.lang||''));
    E.voiceSel.innerHTML='';
    if(!list.length){const o=document.createElement('option');o.value='';o.textContent='(No English voices found)';E.voiceSel.appendChild(o);voiceName='';return list;}
    const saved=localStorage.getItem(LS.voice)||'';
    const pick=list.find(v=>v.name===saved)||list.find(v=>v.name===VOICE_PREF)||list.find(v=>/jenny/i.test(v.name))||list.find(v=>v.default)||list[0];
    voiceName=pick?pick.name:'';
    list.forEach(v=>{const o=document.createElement('option');o.value=v.name;o.textContent=`${v.name} (${v.lang}${v.default?' • default':''})`;if(v.name===voiceName)o.selected=true;E.voiceSel.appendChild(o)});
    return list;
  };
  if('speechSynthesis'in window){window.speechSynthesis.onvoiceschanged=loadVoices}
  const primeSpeech=()=>{if(primed)return;try{window.speechSynthesis.resume()}catch{}try{const u=new SpeechSynthesisUtterance(' ');u.volume=0;window.speechSynthesis.speak(u)}catch{}primed=true};
  const speak=txt=>{if(muted||!('speechSynthesis'in window))return;try{window.speechSynthesis.resume()}catch{};const u=new SpeechSynthesisUtterance(txt);const L=window.speechSynthesis.getVoices();const v=L.find(v=>v.name===voiceName)||L.find(v=>v.name===VOICE_PREF)||L.find(v=>v.default);if(v)u.voice=v;u.rate=1;u.pitch=1;u.volume=1;window.speechSynthesis.speak(u)};

  /* ========= Schedule ========= */
  const parseDipLeads=()=>{const raw=(E.dipLeads.value||'').trim();if(!raw)return[14,5];return raw.split(',').map(s=>parseInt(s.trim(),10)).filter(n=>n>=0&&Number.isFinite(n)).slice(0,4).sort((a,b)=>b-a)};
  const buildSchedule=total=>{
    const out=[];const dip=parseDipLeads();const gLead=Math.max(0,Math.min(60,parseInt(E.greenLead.value,10)||7));
    const push=(kind,tag,t,base,dur,say=null,extra={})=>out.push(Object.assign({kind,tag,t,base,dur,say},extra));
    for(const base of DIP){if(base>total)continue;for(const L of dip){const warn=base+L;if(warn<=total)push('warn','bd',warn,base,0,`Big Dip in ${L} seconds`)}push('start','bd',base,base,0,null)}
    const pack=(arr,g,labels)=>arr.forEach((base,i)=>{if(base>total)return;const raw=labels[i]||'';const loc=E.alt.checked?(ALT[raw]||raw):raw;const tag=g===1?'g1':g===2?'g2':'g3';const dur=5;const warn=base+gLead;if(warn<=total)push('warn',tag,warn,base,dur,loc?`Green ${g} at ${loc} soon`:`Green ${g} soon`,{g,loc});push('start',tag,base,base,dur,null,{g,loc})});
    pack(G1,1,G1L);pack(G2,2,G2L);pack(G3,3,G3L);
    out.sort((a,b)=>b.t-a.t||(a.kind==='warn'?-1:1));
    return out;
  };

  /* ========= Background Hold ========= */
  const setBg=tag=>{E.mechBg.className='bg';if(!tag)return;E.mechBg.classList.add('show',tag)};
  const beginBg=it=>{if(bgHold&&bgHold.tag==='bd')return;bgHold={tag:it.tag,endAt:it.base-it.dur};setBg(it.tag)};
  const maybeClearBg=()=>{if(bgHold&&remaining<bgHold.endAt-1e-3){bgHold=null;setBg(null)}};

  /* ========= Runtime ========= */
  const renderTime=()=>{E.time.textContent=fmt(remaining)};
  const getSeek=()=>Math.max(1,Math.min(30,parseInt(E.seek.value,10)||1));
  const updateSeekLabels=()=>{const v=String(getSeek());E.back.innerHTML=`⟲ -${v}s <span class="kbd">←</span>`;E.fwd.innerHTML=`⟳ +${v}s <span class="kbd">→</span>`};
  const updateNext=()=>{
    for(let i=0;i<schedule.length;i++){
      const it=schedule[i];
      if(it.t<=remaining&&it.kind==='start'&&!fired.has(key(it))){
        const label=it.tag==='bd'?'Big Dip':`Green ${it.tag.slice(1)}`;
        const loc=it.loc?` at <b>${it.loc}</b>`:'';
        E.next.innerHTML=`<span class="pill ${it.tag}">${label}</span> <span class="chip">at <b>${fmt(it.t)}</b>${loc}</span>`;
        return;
      }
    }
    E.next.innerHTML=`<span class="pill bd">Done</span> <span class="chip">All events completed</span>`;
  };
  const updatePlay=()=>{E.play.innerHTML=(running?'⏸ Pause':'▶ Start')+' <span class="kbd">Space</span>'};

  const reset=()=>{running=false;fired.clear();bgHold=null;setBg(null);startTotal=toSec(E.start.value||'09:58');remaining=startTotal;lastSec=remaining|0;schedule=buildSchedule(startTotal);ptr=0;renderTime();updateNext();updatePlay()};
  const start=()=>{if(running)return;startEpoch=performance.now()-(startTotal-remaining)*1000;running=true;tick();updatePlay()};
  const pause=()=>{running=false;updatePlay()};
  const togglePlay=()=>{if(!primed)primeSpeech();running?pause():start()};
  const seekTo=(target,suppress)=>{
    const prev=remaining;remaining=Math.max(0,Math.min(startTotal,target));startEpoch=performance.now()-(startTotal-remaining)*1000;renderTime();
    if(remaining>prev){ptr=0;while(ptr<schedule.length&&schedule[ptr].t>remaining)ptr++;}
    else if(!suppress){while(ptr<schedule.length&&schedule[ptr].t>prev)ptr++;while(ptr<schedule.length&&schedule[ptr].t>=remaining-0.001){const it=schedule[ptr++];if(it.kind==='warn')beginBg(it);const can=(it.tag==='bd'&&E.annBD.checked)||(it.tag==='g1'&&E.annG1.checked)||(it.tag==='g2'&&E.annG2.checked)||(it.tag==='g3'&&E.annG3.checked);if(it.say&&can)speak(it.say);fired.add(key(it));}}
    maybeClearBg();updateNext();
  };
  const rewind=()=>seekTo(remaining+getSeek(),true);
  const forward=()=>seekTo(remaining-getSeek(),false);
  const tick=()=>{
    if(!running)return;const now=performance.now();const elapsed=(now-startEpoch)/1000;const prev=remaining;remaining=Math.max(0,Math.min(startTotal,startTotal-elapsed));
    const sec=remaining|0; if(sec!==lastSec){lastSec=sec;renderTime();}
    while(ptr<schedule.length&&schedule[ptr].t>prev)ptr++;
    while(ptr<schedule.length&&schedule[ptr].t>=remaining-0.001){const it=schedule[ptr++];if(it.kind==='warn')beginBg(it);const can=(it.tag==='bd'&&E.annBD.checked)||(it.tag==='g1'&&E.annG1.checked)||(it.tag==='g2'&&E.annG2.checked)||(it.tag==='g3'&&E.annG3.checked);if(it.say&&can)speak(it.say);fired.add(key(it));}
    maybeClearBg();updateNext();
    if(remaining<=0){running=false;updatePlay();return}
    requestAnimationFrame(tick);
  };

  /* ========= Drawer & Controls ========= */
  const openDrawer=()=>{E.drawer.classList.add('open');E.overlay.classList.add('open');E.drawer.setAttribute('aria-hidden','false');loadVoices()};
  const closeDrawer=()=>{E.drawer.classList.remove('open');E.overlay.classList.remove('open');E.drawer.setAttribute('aria-hidden','true')};
  const toggleDrawer=()=>{(E.drawer.classList.contains('open')?closeDrawer():openDrawer())};

  E.play.addEventListener('click',togglePlay);
  E.back.addEventListener('click',rewind);
  E.fwd.addEventListener('click',forward);
  E.reset.addEventListener('click',reset);
  E.mute.addEventListener('click',()=>{muted=!muted;E.mute.innerHTML=(muted?'🔇 Unmute':'🔈 Mute')+' <span class="kbd">M</span>'});
  E.settings.addEventListener('click',toggleDrawer);
  E.skip.addEventListener('click',()=>{if(!primed)primeSpeech();const warn=schedule.find(it=>it.kind==='warn'&&it.t<=remaining&&!fired.has(key(it)));if(!warn)return;seekTo(Math.min(startTotal,warn.t+.05),true);seekTo(Math.max(0,warn.t-.001),false)});

  E.closeDrawer.addEventListener('click',closeDrawer);
  E.overlay.addEventListener('click',closeDrawer);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawer()});

  // Keyboard shortcuts (ignore when typing)
  window.addEventListener('keydown',e=>{const tag=(e.target||{}).tagName; if(['INPUT','TEXTAREA','SELECT'].includes(tag))return; const k=e.key; if(k===' '||e.code==='Space'){e.preventDefault();togglePlay()} else if(k==='r'||k==='R'){e.preventDefault();reset()} else if(k==='m'||k==='M'){e.preventDefault();E.mute.click()} else if(k==='s'||k==='S'){e.preventDefault();toggleDrawer()} else if(e.code==='ArrowLeft'){e.preventDefault();rewind()} else if(e.code==='ArrowRight'){e.preventDefault();forward()}});

  // Settings changes & persistence
  [E.dipLeads,E.greenLead,E.alt].forEach(el=>el.addEventListener('change',()=>{schedule=buildSchedule(startTotal);ptr=0;updateNext()}));
  E.seek.addEventListener('input',()=>{localStorage.setItem(LS.seek,String(getSeek()));updateSeekLabels()});
  E.defaults.addEventListener('click',()=>{E.start.value='09:58';E.dipLeads.value='14,5';E.greenLead.value='7';E.seek.value='1';E.annBD.checked=E.annG1.checked=E.annG2.checked=E.annG3.checked=true;E.alt.checked=false;updateSeekLabels();schedule=buildSchedule(startTotal);ptr=0;updateNext();voiceName=VOICE_PREF;const L=loadVoices();if(L.length&&E.voiceSel){const f=L.find(v=>v.name===VOICE_PREF)||L.find(v=>/jenny/i.test(v.name))||L.find(v=>v.default)||L[0];if(f){voiceName=f.name;E.voiceSel.value=voiceName}}});
  E.apply.addEventListener('click',()=>{schedule=buildSchedule(startTotal);ptr=0;updateNext()});
  E.save.addEventListener('click',()=>{localStorage.setItem(LS.start,E.start.value||'09:58');localStorage.setItem(LS.dipLead,E.dipLeads.value||'14,5');localStorage.setItem(LS.greenLead,String(Math.max(0,Math.min(60,parseInt(E.greenLead.value,10)||7))));localStorage.setItem(LS.annBD,E.annBD.checked?'1':'0');localStorage.setItem(LS.annG1,E.annG1.checked?'1':'0');localStorage.setItem(LS.annG2,E.annG2.checked?'1':'0');localStorage.setItem(LS.annG3,E.annG3.checked?'1':'0');localStorage.setItem(LS.alt,E.alt.checked?'1':'0');localStorage.setItem(LS.seek,String(getSeek()));localStorage.setItem(LS.voice,voiceName||'');schedule=buildSchedule(startTotal);ptr=0;updateNext()});

  E.voiceSel.addEventListener('change',()=>{voiceName=E.voiceSel.value;localStorage.setItem(LS.voice,voiceName||'')});
  E.testVoice.addEventListener('click',()=>{if(!primed)primeSpeech();speak('Test voice for Dhuum Timer')});

  // Restore persisted
  (function restore(){
    E.start.value=localStorage.getItem(LS.start)||'09:58';
    E.dipLeads.value=localStorage.getItem(LS.dipLead)||'14,5';
    const gl=parseInt(localStorage.getItem(LS.greenLead)||'7',10);
    E.greenLead.value=Math.max(0,Math.min(60,isFinite(gl)?gl:7));
    E.annBD.checked=(localStorage.getItem(LS.annBD)??'1')==='1';
    E.annG1.checked=(localStorage.getItem(LS.annG1)??'1')==='1';
    E.annG2.checked=(localStorage.getItem(LS.annG2)??'1')==='1';
    E.annG3.checked=(localStorage.getItem(LS.annG3)??'1')==='1';
    E.alt.checked=(localStorage.getItem(LS.alt)??'0')==='1';
    const sk=parseInt(localStorage.getItem(LS.seek)||'1',10);E.seek.value=Math.max(1,Math.min(30,isFinite(sk)?sk:1));
    updateSeekLabels();
    voiceName=localStorage.getItem(LS.voice)||VOICE_PREF;
  })();

  // Init
  loadVoices();
  reset();
})();
